import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc1f2bc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-3 container" }
const _hoisted_2 = {
  key: 1,
  class: "space-y-4 flex flex-col justify-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Assign job to a recruiter", -1))
const _hoisted_4 = { class: "w-full justify-center flex" }
const _hoisted_5 = { class: "flex flex-col w-full space-y-3" }
const _hoisted_6 = { class: "w-full flex flex-row items-center space-x-3" }
const _hoisted_7 = { class: "flex flex-row w-9/12 items-center space-x-3" }
const _hoisted_8 = { class: "flex flex-col leading-4" }
const _hoisted_9 = { class: "text-md font-semibold" }
const _hoisted_10 = { class: "text-xs font-base text-gray-400" }
const _hoisted_11 = { class: "flex flex-row w-3/12 items-center justify-end" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "w-6 h-6 flex flex-col justify-center items-center rounded-full bg-primary-light cursor-pointer" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-4 w-4 text-purple-700",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createElementVNode("line", {
      x1: "12",
      y1: "5",
      x2: "12",
      y2: "19"
    }),
    /*#__PURE__*/_createElementVNode("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    })
  ])
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  class: "w-full py-3 flex flex-row justify-center"
}
const _hoisted_16 = {
  key: 1,
  class: "w-full py-5 flex flex-row justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          option: "card"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_SearchInput, { placeholder: "Search recruiter" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `item-card-${i + 1}`,
                class: "flex flex-col px-3 py-3 rounded-lg hover:bg-background-secondary justify-center w-full shadow-2xs hover:scale-125"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Avatar, {
                      name: `${item.first_name} ${item.last_name}`,
                      size: "xs"
                    }, null, 8, ["name"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _withModifiers(($event: any) => (_ctx.updateJob(item.id)), ["stop"])
                    }, _hoisted_14, 8, _hoisted_12)
                  ])
                ])
              ]))
            }), 128))
          ]),
          (_ctx.data?.length > 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_Paginator, {
                  modelValue: _ctx.page,
                  page: _ctx.page,
                  pages: _ctx.paginator.pagination.total_pages,
                  "range-size": 1,
                  "onUpdate:modelValue": _ctx.updateHandler,
                  total: _ctx.paginator.pagination.total_count,
                  from: _ctx.paginator.pagination.from,
                  to: _ctx.paginator.pagination.to
                }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.data?.length <= 0 && !_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16))
            : _createCommentVNode("", true)
        ]))
  ]))
}